import LinkButton from '@ovpn/ui/link-button';

import { boxed, withNavigate } from '@sso/shared/hocs';

export default boxed(withNavigate(LinkButton));
